import React from 'react'
import PropTypes from 'prop-types'
import { RecaptchaWrapper } from './Recaptcha.style'

class Recaptcha extends React.Component {
  constructor(props) {
    super(props)

    const { sitekey, hl, verifyCallback } = this.props

    this.renderRecaptcha = () => {
      const params = {
        sitekey,
        callback: verifyCallback,
        size: 'invisible',
      }

      try {
        // @ts-ignore
        window.grecaptcha.render('container', params)
      } catch (error) {
        console.warn(error)
      }
    }

    this.injectScript = () => {
      // @ts-ignore
      window.recaptchaLoadedHandler = () => {
        this.renderRecaptcha()
      }

      const script = document.createElement('script')
      script.async = true
      script.defer = true
      script.onerror = (error) => {
        throw error
      }
      script.src = `https://www.google.com/recaptcha/api.js?hl=${hl}&onload=recaptchaLoadedHandler&render=explicit`
      script.type = 'text/javascript'
      document.body.appendChild(script)
    }

    this.execute = () => {
      // @ts-ignore
      if (window.grecaptcha && window.grecaptcha.execute) {
        // @ts-ignore
        window.grecaptcha.execute()
      }
    }
  }

  componentDidMount() {
    this.injectScript()
  }

  render() {
    return <RecaptchaWrapper id="container" />
  }
}

Recaptcha.propTypes = {
  hl: PropTypes.string,
  sitekey: PropTypes.string.isRequired,
  verifyCallback: PropTypes.func.isRequired,
}

Recaptcha.defaultProps = {
  hl: 'en',
}

export default Recaptcha
